import React from 'react';
const Example = () => (<section className="mb-9 mb-lg-0 shadow-uniform card">
        <div className="card-body">
            <div>
                <div className="mb-7">
                    <h2>
                        Cena:&nbsp;
                        <span className="price-original text-nowrap">1&nbsp;490&nbsp;Kč&nbsp;s DPH</span>
                    </h2>
                    <h2 className="price-discount">
                        Týden slev - sleva 30 %:&nbsp;
                        <strong itemProp="offers" itemScope={true} itemType="http://schema.org/Offer">
                            <meta itemProp="price" content="1790"/>
                            <meta itemProp="priceCurrency" content="CZK"/>
                            1&nbsp;250&nbsp;Kč
                        </strong>
                        &nbsp;
                        <span className="text-nowrap">s DPH</span>
                    </h2>
                    <p>
                        <strong>Platí do 14. 6. 2018</strong>
                    </p>
                </div>
                <div className="row mb-5">
                    <div className="col-7 col-md-3 col-lg-7">Počet lekcí:</div>
                    <div className="col-5 col-md-9 col-lg-5">
                        <strong>20</strong>
                    </div>
                </div>
                <div className="row mb-7">
                    <div className="col-7 col-md-3 col-lg-7">Celková délka videí:</div>
                    <div className="col-5 col-md-9 col-lg-5">
                        <strong>2:05 hod</strong>
                    </div>
                </div>
                <p>
                    <a href="#">Garance vrácení peněz</a>, Certifikát absolventa, Neomezený přístup
                </p>
            </div>
            <a href="#" className="btn btn-primary btn-large btn-block">
                Koupit kurz
            </a>
        </div>
    </section>);
export default Example;
